import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PLAYOFF_SERIES_SMALL_SCREEN_QUERY = '@media (max-width: 767px) and (min-width: 360px)';
export const PLAYOFF_SERIES_SMALLEST_SCREEN_QUERY = '@media (max-width: 359px)';

export const SeriesHeaderWrapper = styled.div`
    height: 56px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 42px;
        flex-direction: row;
        align-items: center;
    }

    a {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        white-space: nowrap;

        color: ${({ theme }) => theme.Utility.cta};

        path {
            color: ${({ theme }) => theme.Utility.cta};
            transition: 0.3s;
        }

        &:hover {
            path {
                color: ${({ theme }) => theme.Text.primary};
            }
        }
    }
`;

export const PlayoffSeriesPicker = styled.div`
    margin-bottom: 40px;
`;
